import type { ImageType } from "@/types/baseTypes";

export const hasCopyrightContent = (image?: ImageType): boolean =>
  !!(image?.acf?.text_1 || image?.acf?.text_2);
